import { TbFileDescription } from 'react-icons/tb';

export const FormatFileIcon = () => <TbFileDescription size={32} strokeWidth={1.8} />;
